import { auth } from '../firebase.config'
import { getFunctions, httpsCallable } from 'firebase/functions'

const PLAN_PRICES: Record<string, string> = {
  field: '$49/mo',
  premium: '$149/mo',
  enterprise: '$299/mo',
}

export function getPlanPrice(plan: string) {
  return PLAN_PRICES[plan] || ''
}

export async function createCheckoutSession(targetPlan: string): Promise<void> {
  try {
    const functions = getFunctions()
    const checkoutFn = httpsCallable(functions, 'createStripeCheckout')
    const result: any = await checkoutFn({ planName: targetPlan })
    if (result.data?.url) {
      window.location.href = result.data.url
    } else {
      throw new Error('No checkout URL returned')
    }
  } catch (err: any) {
    console.error('Stripe checkout error:', err)
    alert('Failed to create checkout session.')
  }
}

export async function openBillingPortal(): Promise<void> {
  try {
    const functions = getFunctions()
    const portalFn = httpsCallable(functions, 'createStripePortal')
    const result: any = await portalFn({})
    if (result.data?.url) {
      window.location.href = result.data.url
    } else {
      throw new Error('No portal URL returned')
    }
  } catch (err: any) {
    console.error('Stripe portal error:', err)
    alert('Failed to open billing portal.')
  }
}
